import Benefits_1 from '../../Assets/benefits_1.png'
import Benefits_2 from '../../Assets/benefits_2.png'
import Benefits_3 from '../../Assets/benefits_3.png'
import Benefits_4 from '../../Assets/benefits_4.png'
import Benefits_5 from '../../Assets/benefits_5.png'
import * as S from './style'

export const Benefits = () => {
  return (
    <S.Content>
      <S.Wrapper id='benefits'>
        <S.TextBox>

          <S.Title >
            Resultados que vão além da manutenção
          </S.Title>

          <S.Text >
            Com a WisePrevent, você reduz custos, prolonga a vida útil dos ativos e tem total controle do que foi feito, por quem e quando.<br />Tudo rastreável, auditável e pronto para apresentar à gestão ou aos órgãos reguladores.
          </S.Text>

        </S.TextBox>


      </S.Wrapper>
      <S.WrapperCardsGrid>
        <div className="luminosity-benefits" />
        <S.CardsGrid>

          <S.TopRow>
            <S.Card className="card1">

              <S.TextCardBox>
                <h3>
                  Redução de custos Invisíveis
                </h3>

                <p>
                  Evite manutenções de última hora e ações emergenciais.<br />Até 40% de economia com planejamento preditivo.
                </p>

              </S.TextCardBox>

              <img src={Benefits_1} alt="Imagem 1" />
            </S.Card>

            <S.Card className="card2" >

              <S.TextCardBox>
                <h3>
                  ROI mensurável com dados reais
                </h3>
                <p>
                  Tudo o que sua operação economiza ou evita vira número — pronto para relatório.
                </p>
              </S.TextCardBox>

              <img src={Benefits_2} alt="Imagem 1" style={{ width: '411px' }} />
            </S.Card>
          </S.TopRow>

          <S.Card className="card3">

            <S.TextCardBox>
              <h3>
                Manutenções organizadas e rastreáveis
              </h3>
              <p>
                Cada inspeção tem checklist, responsável, data, hora e evidência registrada.
              </p>
            </S.TextCardBox>

            <img src={Benefits_3} alt="Imagem 1" />
          </S.Card>

          <S.Card className="card4">

            <S.TextCardBox>
              <h3>
                Conformidade Garantida
              </h3>
              <p>
                Transparência total para auditorias, stakeholders e órgãos reguladores.
              </p>
            </S.TextCardBox>

            <img src={Benefits_4} alt="Imagem 1" />
          </S.Card>

          <S.Card className="card5">

            <S.TextCardBox>
              <h3>
                Vida útil maior para ativos críticos
              </h3>
              <p>
                Ativos bem cuidados duram mais — e você adia reinvestimentos caros.
              </p>
            </S.TextCardBox>

            <img src={Benefits_5} alt="Imagem 1" />
          </S.Card>
        </S.CardsGrid>
      </S.WrapperCardsGrid>

    </S.Content>
  )
}
